import type { Step } from "react-joyride";

export const promotionHistoryTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ສະແດງປະຫວັດການເລື່ອນຕຳແໜ່ງແບບ timeline. ທ່ານສາມາດກັ່ນຕອງຕາມພະນັກງານ, ເດືອນ/ປີ ແລະ ຕຳແໜ່ງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-history-header"]',
    content:
      "ຫົວຂໍ້ປະຫວັດການເລື່ອນຕຳແໜ່ງ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-history-filter"]',
    content:
      "ເລືອກພະນັກງານ, ປີ/ເດືອນ, ຕຳແໜ່ງ ແລະ ຄົ້ນຫາເພື່ອກັ່ນຕອງປະຫວັດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-history-timeline"]',
    content:
      "Timeline ສະແດງລາຍການເລື່ອນຂັ້ນຕາມເວລາ. ໂຫຼດເພີ່ມເພື່ອເບິ່ງເພີ່ມ.",
    placement: "top",
  },
];
